import { MediaType } from '@/constants/constants';
import { IFormFieldType } from '@/widgets/create-widget';

const NoticeBannerSchema: { [key: string]: IFormFieldType } = {
  noticeBanner: {
    type: 'Object',
    label: 'Notice Banner',
    required: false,
    children: {
      banner: {
        type: 'Media',
        mediaTypes: [MediaType.IMAGE],
        label: 'Web Banner',
        required: false,
      },
      mWebBanner: {
        type: 'Media',
        mediaTypes: [MediaType.IMAGE],
        label: 'Mobile Web Banner',
        required: false,
      },
      urlToOpen: {
        type: 'String',
        label: 'URL to Open',
        required: false,
      },
    },
  },
};

export default NoticeBannerSchema;

export type NoticeBannerProps = {
  banner: string;
  mWebBanner: string;
  urlToOpen: string;
};

export type NoticeBannerWidgetProps = {
  noticeBanner: NoticeBannerProps;
};

export const NoticeBannerDefaultValues: NoticeBannerWidgetProps = {
  noticeBanner: {
    banner:
      'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/7a3aacd5-836d-4c8c-ba49-2fc17448b0bb.webp',
    mWebBanner:
      'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/a6337d4c-fd58-4ce4-8713-74e0dbe58502.webp',
    urlToOpen: '',
  },
};
